module.exports = {"652925100":"新和镇","652925101":"尤鲁都斯巴格镇","652925102":"依其艾日克镇","652925201":"排先拜巴扎乡","652925202":"塔什艾日克乡","652925203":"渭干乡","652925204":"玉奇喀特乡","652925205":"塔木托格拉克乡","652925400":"桑塔木农场","652925401":"新和县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652925.json
// module id = 2879
// module chunks = 0